import { ResgateModel } from 'src/app/models/resgate-model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

// Model
import { ResponseBase } from '../models/response-base';
import { PedidoCadastro, PedidoCadastroItemArquivo } from '../models/pedido-cadastro';
import { PedidoInfo } from '../models/pedido-info';
import { MeioPagamentoPedido } from '../models/meio-pagamento-pedido';
import { SituacaoPedido } from '../shared/enums/situacao-pedido.enum';
import { Pedido, PedidoItem } from '../models/pedido';
import { ResgatarBeneficioModel } from '../models/ResgatarBeneficioModel';
import { BeneficioValor } from '../models/BeneficioValor';
import { LimiteResgateRequestModel } from '../models/LimiteResgateRequestModel';
import { SimpleValueModel } from '../models/SimpleValueModel';
import { OpcaoPedidoArquivo } from '../models/opcao-pedido-arquivo';
import { PedidoCadastroArquivo } from '../models/pedido-cadastro-arquivo';
import { TransferenciaBeneficio } from '../models/transferencia-beneficio';
import { TransferenciaBeneficioModel } from '../models/transferencia-beneficio-model';
import { ExtratoPedidoFilterOptions } from '../shared/helpers/models/extrato-pedido-filter-options';
import { PedidosRequestModel } from '../models/pedidos-request-model';
import { Purchase, PurchaseSummary, PurchaseItens, OrderSummary, PurchasesList } from '../models/purchase';
import { SituacaoCompra } from '../shared/enums/situacao-compra.enum';
import { OrderItemPaged } from '../models/order-item-paged';
import { OrderItemRequest } from '../models/request/order-item-request';
import { PurchaseBatch, PurchaseFile } from '../models/compra-batch';
import { ValuesPurchaseRequest } from '../models/purchase-values';

@Injectable({
    providedIn: 'root'
})
export class PedidoService {

    API: string = environment.API + 'Portal/pedidos';
    APICompra: string = environment.API + 'Portal/compra';

    APIPurchase: string = environment.API + 'purchase';
    APIOrder: string = environment.GATEWAY + 'purchase/order';
    APIMeioPagamento: string = environment.API + 'Portal/meiospagamentos/pedidos';
    private URL = environment.GATEWAY + 'purchase';
    private NEW_API_PURCHASE = environment.GATEWAY + 'purchases';

    constructor(private http: HttpClient) { }

    saveDraftOrder(cedenteGuid: string, gestorGuid: string, pedidoCadastro: PedidoCadastro): Observable<ResponseBase<Pedido>> {
        return this.http.post<ResponseBase<Pedido>>(`${this.API}/lastSaved/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, pedidoCadastro);
    }

    createOrder(cedenteGuid: string, gestorGuid: string, pedidoCadastro: PedidoCadastro): Observable<ResponseBase<PedidoInfo>> {
        return this.http.post<ResponseBase<PedidoInfo>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, pedidoCadastro);
    }

    /*Create order nova API  */
    createPurchase(assignorGuid: string, purchase: Purchase) {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        return this.http.post<ResponseBase<Purchase>>(`${this.URL}/create/assignor/${assignorGuid}`, purchase, {headers});
    }

    updatePurchase(assignorGuid: string, purchase: Purchase){
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        return this.http.put<ResponseBase<Purchase>>(`${this.URL}/update/assignor/${assignorGuid}`, purchase, {headers});
    }


    finishPurchase(assignorGuid: string, purchaseItens: Purchase): Observable<ResponseBase<Purchase>> {
        return this.http.post<ResponseBase<Purchase>>(`${this.APIPurchase}/finish/${assignorGuid}`, purchaseItens);
    }

    getPurcharses(situacoesCompra: SituacaoCompra[], cedenteGuid: string, offset: number, limit: string): Observable<ResponseBase<PurchasesList>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');

        let purchasesParams = new HttpParams();
        situacoesCompra.forEach((param: SituacaoCompra) => {
            purchasesParams = purchasesParams.append(`purchaseStatus`, param.toString());
        });
        purchasesParams = purchasesParams.append(`offset`,offset.toString());
        purchasesParams = purchasesParams.append(`limit`,limit);
        return this.http.get<ResponseBase<PurchasesList>>(`${this.URL}/purchases/assignor/${cedenteGuid}`,{params: purchasesParams ,headers});
    }

    getPurchaseById(pedidoId: number, cedenteGuid: string, returnAnexo): Observable<ResponseBase<Purchase>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        let purchaseParam = new HttpParams();
        purchaseParam = purchaseParam.append(`returnAnexo`, returnAnexo.toString());

        return this.http.get<ResponseBase<Purchase>>(`${this.URL}/purchases/detail/${pedidoId}/assignor/${cedenteGuid}`, {params: purchaseParam, headers});
    }

    getOrderItemsOrderId(orderId: number, assingorGuid: string, offset: number, limit: number, orderItemRequest: OrderItemRequest): Observable<ResponseBase<OrderItemPaged>>{
        return this.http.post<ResponseBase<OrderItemPaged>>(`${this.APIOrder}/items/${orderId}/${assingorGuid}/page/${offset}/limit/${limit}`, orderItemRequest)
    }

    getLastPurchases(situacoesPedido: SituacaoCompra[], quantidade: number, cedenteGuid: string): Observable<ResponseBase<PurchaseSummary[]>>{
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        let situacoesPedidoParams = new HttpParams();
        situacoesPedido.forEach((param: SituacaoCompra) => {
            situacoesPedidoParams = situacoesPedidoParams.append(`purchaseStatus`, param.toString());
        });
        return this.http.get<ResponseBase<PurchaseSummary[]>>(`${this.URL}/last/${cedenteGuid}/${quantidade}`, { params: situacoesPedidoParams });
    }

    getLastOrders(situacoesPedido: SituacaoPedido[], quantidade: number, cedenteGuid: string): Observable<ResponseBase<OrderSummary[]>>{
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        let situacoesPedidoParams = new HttpParams();
        situacoesPedido.forEach((param: SituacaoPedido) => {
            situacoesPedidoParams = situacoesPedidoParams.append(`orderStatus`, param.toString());
        });
        return this.http.get<ResponseBase<OrderSummary[]>>(`${this.APIOrder}/last-five/${cedenteGuid}/${quantidade}`, { params: situacoesPedidoParams });
    }

    reprocessPurchase(purchaseId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Purchase>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        let gestorGuidParam = new HttpParams();
        gestorGuidParam = gestorGuidParam.append(`managerGuid`, gestorGuid);
        return this.http.put<ResponseBase<Purchase>>(`${this.URL}/reprocess/${purchaseId}/assignor/${cedenteGuid}/manager/${gestorGuid}`,null,{headers: headers, params: gestorGuidParam});
    }

    cancelPurchase(purchaseId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Purchase>> {
        let headers = new HttpHeaders();
        headers = headers.append('Gateway', 'true');
        let gestorGuidParam = new HttpParams();
        gestorGuidParam = gestorGuidParam.append(`managerGuid`, gestorGuid);
        return this.http.delete<ResponseBase<Purchase>>(`${this.URL}/cancel/${purchaseId}/assignor/${cedenteGuid}/manager/${gestorGuid}`,{headers: headers, params: gestorGuidParam});
    }
    /* Fim */

    getMeiosPagamentosOrder(): Observable<ResponseBase<MeioPagamentoPedido[]>> {
        return this.http.get<ResponseBase<MeioPagamentoPedido[]>>(`${this.APIMeioPagamento}/ativos`);
    }

    getPedidos(situacoesPedido: SituacaoPedido[], cedenteGuid: string): Observable<ResponseBase<Pedido[]>> {
        let situacoesPedidoParams = new HttpParams();
        situacoesPedido.forEach((param: SituacaoPedido) => {
            situacoesPedidoParams = situacoesPedidoParams.append(`situacoesPedido`, param.toString());
        });
        return this.http.get<ResponseBase<Pedido[]>>(`${this.API}/cedentes/${cedenteGuid}`, { params: situacoesPedidoParams });
    }

    getById(pedidoId: number, cedenteGuid: string): Observable<ResponseBase<Pedido>> {
        return this.http.get<ResponseBase<Pedido>>(`${this.API}/${pedidoId}/cedentes/${cedenteGuid}`);
    }

    cancel(pedidoId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Pedido>> {
        return this.http.delete<ResponseBase<Pedido>>(`${this.API}/${pedidoId}/cancelar/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
    }

    desprovisionarPedidoItem(purchaseId: number, pedidoId: number, pedidoItemId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<PedidoItem>> {
        return this.http.delete<ResponseBase<PedidoItem>>(`${this.APICompra}/${purchaseId}/pedidos/${pedidoId}/pedidoItens/${pedidoItemId}/desprovisionar/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
    }

    reprocessar(pedidoId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Pedido>> {
        return this.http.put<ResponseBase<Pedido>>(`${this.API}/${pedidoId}/reprocessar/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, null);
    }

    reprocessarPedidoItem(pedidoId: number, pedidoItemId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<PedidoItem>> {
        return this.http.put<ResponseBase<PedidoItem>>(`${this.API}/${pedidoId}/pedidoItens/${pedidoItemId}/reprocessar/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, null);
    }

    getUltimosPedidos(situacoesPedido: SituacaoPedido[], quantidade: number, cedenteGuid: string): Observable<ResponseBase<Pedido[]>> {
        let situacoesPedidoParams = new HttpParams();
        situacoesPedido.forEach((param: SituacaoPedido) => {
            situacoesPedidoParams = situacoesPedidoParams.append(`situacoesPedido`, param.toString());
        });
        return this.http.get<ResponseBase<Pedido[]>>(`${this.API}/ultimos/quantidade/${quantidade}/cedentes/${cedenteGuid}`, { params: situacoesPedidoParams });
    }

    ResgatarBeneficio(resgatarBeneficioModel: ResgatarBeneficioModel): Observable<ResponseBase<BeneficioValor[]>> {
        return this.http.post<ResponseBase<BeneficioValor[]>>(`${this.API}/resgatar`, resgatarBeneficioModel);
    }

    ObterValorLimiteResgate(limiteResgateRequestModel: LimiteResgateRequestModel): Observable<ResponseBase<SimpleValueModel>> {
        return this.http.post<ResponseBase<SimpleValueModel>>(`${this.API}/limite-resgate`, limiteResgateRequestModel);
    }

    //#region
    getOpcoesArquivo(): Observable<ResponseBase<OpcaoPedidoArquivo[]>> {
        return this.http.get<ResponseBase<OpcaoPedidoArquivo[]>>(`${this.API}/arquivo/opcoes`);
    }

    createOrderByFile(assignoreGuid: string, managerGuid: string, pedido: PedidoCadastroArquivo): Observable<ResponseBase<Purchase>> {
        return this.http.post<ResponseBase<Purchase>>(`${this.URL}/create/file/assignor/${assignoreGuid}/manager/${managerGuid}`, pedido);
    }

    //#endregion
    ObterHistoricoResgate(colaboradorId: number, cedenteGuid: string): Observable<ResponseBase<ResgateModel[]>> {
        return this.http.get<ResponseBase<ResgateModel[]>>(`${this.API}/historico-resgate/${colaboradorId}/cedente/${cedenteGuid}`);
    }

    TransfereBeneficio(resgatarBeneficioModel: TransferenciaBeneficio): Observable<ResponseBase<BeneficioValor[]>> {
        return this.http.post<ResponseBase<BeneficioValor[]>>(`${this.API}/transferir-beneficio`, resgatarBeneficioModel);
    }

    ObterHistoricoTransferenciaBeneficio(colaboradorId: number, cedenteGuid: string): Observable<ResponseBase<TransferenciaBeneficioModel[]>> {
        return this.http.get<ResponseBase<TransferenciaBeneficioModel[]>>(`${this.API}/historico-transferencia_beneficio/${colaboradorId}/cedente/${cedenteGuid}`);
    }

    ObterPedidosComFiltro(pedidosRequestModel: PedidosRequestModel): Observable<ResponseBase<Pedido[]>> {
        return this.http.post<ResponseBase<Pedido[]>>(this.API, pedidosRequestModel);
    }

    UpdateReleaseDatePurchase(purchaseId: number, assignorGuid: string, managerGuid: string, releaseDate: Date): Observable<ResponseBase<boolean>> {
        return this.http.put<ResponseBase<boolean>>(`${this.NEW_API_PURCHASE}/${purchaseId}/assignors/${assignorGuid}/managers/${managerGuid}/release-date`, releaseDate);
    }

    CreatePurchaseByFile(assignorGuid: string, managerGuid: string, purchase: PurchaseFile): Observable<ResponseBase<PurchaseBatch>> {
        return this.http.post<ResponseBase<PurchaseBatch>>(`${this.NEW_API_PURCHASE}/assignors/${assignorGuid}/managers/${managerGuid}/file`, purchase);
    }
    
    getStatusBatch(batchId: number, assignorGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        headers = headers.append('no-loader', 'true');
        return this.http.get<ResponseBase<any>>(`${this.NEW_API_PURCHASE}/batch/status/${batchId}/assignor/${assignorGuid}`, { headers });
    }

    getBatchErrors(batchId: number, assignorGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        return this.http.get<ResponseBase<any>>(`${this.NEW_API_PURCHASE}/batch/download/${batchId}/assignor/${assignorGuid}`, { headers });
    }
    
    UpdatePurchaseValues(valuesPurchase: ValuesPurchaseRequest, assignorGuid: string, managerGuid: string): Observable<ResponseBase<any>> {
        let headers = new HttpHeaders();
        return this.http.put<ResponseBase<any>>(`${this.NEW_API_PURCHASE}/assignors/${assignorGuid}/managers/${managerGuid}/values`, valuesPurchase);
    }
}
